import { NgModule } from '@angular/core';
import { NumberFormatPipe } from './numberFormatPipe';

@NgModule({
    declarations: [NumberFormatPipe],
    exports: [NumberFormatPipe]
})
export class NumberFormatPipeModule { }
